// extracted by mini-css-extract-plugin
export default {"loading":"Blog_loading__wIPR0","grow":"Blog_grow__zANHz","blogBody":"Blog_blogBody__CQpqj","blogHeader":"Blog_blogHeader__OnBV6","postBody":"Blog_postBody__o6csq"};